export * from "./HeadingTitle"